import {analyticsLogEvent} from '../api'

type LayerAction = 'open' | 'close'

interface Parameters {
    /** Interaction with the layer: open on first display, close on dismiss. */
    action: LayerAction
}

/**
 * @name analyticsEventPdpColorLayer
 *
 * @event
 *
 * @description
 * Tracks the PDP color-selector layer open/close (the drawer/popover opened from the
 * "+ N colori" CTA, both inline and from the stickybar).
 * Manuale BitBang "GTM Tracciamenti – PDP PWA" v1.0 §3.1.4.
 *
 * dataLayer shape:
 * `{ event: 'custom_event', eventCategory: 'pdp_color_layer', eventAction: 'select color', eventLabel: 'open'|'close' }`
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {LayerAction} params.action - open/close, mapped to `eventLabel`.
 */
export function analyticsEventPdpColorLayer({action}: Parameters) {
    analyticsLogEvent('custom_event', {
        eventCategory: 'pdp_color_layer',
        eventAction: 'select color',
        eventLabel: action,
    })
}

/**
 * @name analyticsEventPdpColorLayerSelect
 *
 * @event
 *
 * @description
 * Tracks the actual color selection (click on a color swatch that changes the active variation group),
 * complementing the open/close events above.
 * Manuale BitBang "GTM Tracciamenti – PDP PWA" v1.0 §3.1.4.
 *
 * dataLayer shape:
 * `{ event: 'custom_event', eventCategory: 'pdp_color_layer', eventAction: 'select color', eventLabel: 'click' }`
 */
export function analyticsEventPdpColorLayerSelect() {
    analyticsLogEvent('custom_event', {
        eventCategory: 'pdp_color_layer',
        eventAction: 'select color',
        eventLabel: 'click',
    })
}
